// extracted by mini-css-extract-plugin
module.exports = {"loading":"EmpHistoryAndUtilizeReportForm_loading__n6Z9F","switchStyle":"EmpHistoryAndUtilizeReportForm_switchStyle__7JHz3"};